import React from 'react'

export default function Main({ children }) {
    return (
        <>
            {children}
        </>
    )
}
